const AboutPage = () => {
  const markets = [
    {
      icon: 'ri-global-line',
      title: 'Exportação',
      description: 'Atendendo a diversos países da América Latina, África e Ásia'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Marcas Próprias',
      description: 'Atendendo aos principais players do mercado de varejo, desde o desenvolvimento de produtos até sua finalização de embalagens'
    },
    {
      icon: 'ri-tools-line',
      title: 'Taylor Made',
      description: 'Desenvolvendo para nosso cliente o produto ou ingrediente ideal para sua produção'
    },
    {
      icon: 'ri-factory-line',
      title: 'Industrialização',
      description: 'Com a produção de volumes excedentes à sua planta fabril ou sazonais'
    },
    {
      icon: 'ri-government-line',
      title: 'Institucional',
      description: 'Alimentação Escolar e Forças Armadas, atendendo às exigências de editais'
    },
    {
      icon: 'ri-restaurant-2-line',
      title: 'Food Service',
      description: 'Com equipe de vendas e gestores regionais em todo Brasil'
    }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Confiança',
      color: 'from-blue-500 to-cyan-600'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Inovação',
      color: 'from-blue-600 to-cyan-500'
    },
    {
      icon: 'ri-heart-line',
      title: 'Respeito',
      color: 'from-cyan-500 to-blue-600'
    },
    {
      icon: 'ri-medal-line',
      title: 'Seriedade',
      color: 'from-blue-700 to-cyan-600'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-blue-50 via-white to-cyan-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Soluções para seu negócio
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* New TECNUTRI Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-2xl text-blue-600 font-semibold mb-8">
              Sabor que transforma, praticidade que inspira.
            </p>
          </div>

          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <p>
              Na <strong>Sustentare</strong>, acreditamos que cozinhar deve ser tão prazeroso quanto servir. Nossa missão é simplificar o dia a dia das cozinhas profissionais, oferecendo produtos em pó de alta qualidade que mantêm o sabor autêntico e a textura perfeita — sem abrir mão da agilidade que seu negócio precisa.
            </p>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 my-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Mais do que ingredientes, oferecemos soluções:
              </h3>
              <p className="text-lg text-gray-700">
                ⏱️ Tempo transformado em criatividade, para você focar no que realmente importa: encantar seus clientes
              </p>
            </div>

            <p>
              Nascemos para ser o parceiro ideal de bares, restaurantes, hotéis e buffets — lugares onde a comida é memória, tradição e, acima de tudo, amor disfarçado de profissão. Aqui, a praticidade não é só sobre velocidade: é sobre permitir que cada prato conte sua própria história, com a consistência e o cuidado que só a Sustentare oferece.
            </p>

            <p className="text-xl font-semibold text-blue-600 text-center mt-8">
              Porque acreditamos que, por trás de todo bom prato, existe um chef com tempo para criar.
            </p>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20Brazilian%20food%20manufacturing%20facility%20with%20state-of-the-art%20equipment%20and%20quality%20control%20systems%2C%20professional%20food%20production%20environment%2C%20clean%20and%20organized%20industrial%20kitchen%2C%20workers%20in%20white%20uniforms%20and%20hairnets%20following%20strict%20hygiene%20protocols%2C%20stainless%20steel%20machinery%20and%20production%20lines%2C%20bright%20lighting%2C%20emphasis%20on%20food%20safety%20and%20quality%20standards%2C%20contemporary%20industrial%20design%20with%20blue%20and%20cyan%20accent%20colors&width=600&height=500&seq=about-factory-1&orientation=landscape"
                  alt="Fábrica Sustentare"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Sustentare
              </h2>
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
                <p>
                  Somos uma empresa brasileira fundada em <strong>1996</strong>, produzindo alimentos em pó para diversos canais de vendas. Com auditorias frequentes, prezamos pela qualidade dos ingredientes utilizados, bem como de nossos produtos.
                </p>
                <p>
                  Com um portfólio variado, entregamos mais que produtos... Entregamos <strong>praticidade</strong> e a <strong>garantia</strong> de um produto com ingredientes selecionados com resultado final que atende os mais exigentes clientes e transformadores.
                </p>
                <p>
                  Produtos elaborados para facilitar e otimizar o tempo, além de ingredientes para as mais diversas preparações.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Markets Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Atuamos em diversos mercados
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nossa expertise abrange múltiplos segmentos, oferecendo soluções personalizadas para cada necessidade
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {markets.map((market, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${market.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {market.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {market.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-cyan-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="bg-gradient-to-br from-blue-500 to-cyan-500 rounded-3xl p-12 lg:p-16 text-white shadow-2xl">
            <div className="text-center mb-12">
              <i className="ri-handshake-line text-6xl mb-6"></i>
              <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                Parceria e Confiança
              </h2>
            </div>
            <p className="text-xl lg:text-2xl text-center leading-relaxed mb-8">
              Grandes marcas e players de mercado, nacionais e internacionais, encontram na Sustentare, a parceria e confiança que necessitam para alavancarem seus negócios!
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              A nossa receita é simples
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto mb-8"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className={`w-20 h-20 bg-gradient-to-br ${value.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                  <i className={`${value.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">
                  {value.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
            Pronto para crescer com a Sustentare?
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Entre em contato conosco e descubra como podemos ajudar seu negócio a alcançar novos patamares
          </p>
          <a
            href="/contato"
            className="inline-flex items-center px-10 py-5 bg-gradient-to-r from-blue-500 to-cyan-500 text-white text-lg font-semibold rounded-xl hover:from-blue-600 hover:to-cyan-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-3 text-2xl"></i>
            Fale Conosco
          </a>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;